import React from 'react'
import { Form as FormikForm, FormikFormProps } from 'formik'

export const Form = function Form({
  ref,
  children,
  ...props
}: FormikFormProps & {
  ref?: React.RefObject<HTMLFormElement | null>
}) {
  return (
    <FormikForm ref={ref} translate="yes" {...props}>
      {children}
    </FormikForm>
  )
}
